"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CookieService_jar;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieService = void 0;
const Common_1 = require("./Common");
const COOKIE_DELIMITER = /;\s*/;
const COOKIE_NAME_VALUE_DELIMITER = /=/;
class CookieService {
    constructor() {
        _CookieService_jar.set(this, {});
        this.load();
    }
    load() {
        const cookies = document.cookie;
        const jar = {};
        cookies.split(COOKIE_DELIMITER).forEach((cookie) => {
            const parts = cookie.split(COOKIE_NAME_VALUE_DELIMITER);
            const name = parts[0];
            const rawValue = parts.slice(1).join("");
            jar[name] = decodeURIComponent(rawValue);
        });
        // extract only those that are needed
        __classPrivateFieldSet(this, _CookieService_jar, {
            [Common_1.ANONYMOUS_ID_COOKIE_NAME]: jar[Common_1.ANONYMOUS_ID_COOKIE_NAME],
        }, "f");
    }
    get(name) {
        return __classPrivateFieldGet(this, _CookieService_jar, "f")[name];
    }
    get unnamedUserId() {
        this.load();
        return this.get(Common_1.ANONYMOUS_ID_COOKIE_NAME);
    }
}
exports.CookieService = CookieService;
_CookieService_jar = new WeakMap();
